import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { set, when } from 'cerebral/factories'
import { props, state } from 'cerebral'

export const find = [
  //
  actions.find,
  saveEntities(),
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  saveEntities(),
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Print order saved', type: 'success' }),
  actions.getDraftPrintOrders,
  route.toPrintOrders,
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Print order deleted', type: 'success' }),
  findForList,
]

export const getEstimatePricing = [
  //
  actions.getEstimatePricing,
]

export const getShippingMethods = [
  //
  actions.getShippingMethods,
]

export const getDraftPrintOrders = [
  //
  when(state`account.currentUser`),
  {
    true: [
      when(state`account.packages.print-orders`),
      {
        true: [
          //
          actions.getDraftPrintOrders,
        ],
        false: [],
      },
    ],
    false: [],
  },
]
